// extracted by mini-css-extract-plugin
module.exports = {"appBottomSpacing":"App_appBottomSpacing__q2u7Q"};